import type { FetchResponse, TurboBeforeFetchResponseEvent } from '@hotwired/turbo'

export type FormAnswer = Pick<TurboBeforeFetchResponseEvent, 'target' | 'preventDefault'> & {
  detail: { fetchResponse: Pick<FetchResponse, 'clientError' | 'location'> }
}

interface Form {
  method: string
  closest: (selector: string) => unknown
  getAttribute: (name: string) => string | null
}

function isForm(target: EventTarget | null): target is EventTarget & Form {
  return target !== null && 'method' in target && 'closest' in target && 'getAttribute' in target
}

function answersIntoFrame(form: Form): boolean {
  const named = form.getAttribute('data-turbo-frame')
  return named === null ? form.closest('turbo-frame') !== null : named !== '_top'
}

export function loadFailedGetFormInFull(
  event: FormAnswer,
  load: (href: string) => void = (href) => window.location.assign(href),
): void {
  const { target, detail } = event
  if (!isForm(target) || target.method !== 'get' || answersIntoFrame(target)) return
  if (!detail.fetchResponse.clientError) return

  event.preventDefault()
  load(detail.fetchResponse.location.href)
}
